import { Slider, type SliderProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'


interface Props extends SliderProps {
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Slider ref={ref} { ...props } />
  )
})


export {
  Component as Slider,
  type Props as SliderProps,
}